module.exports = __webpack_public_path__ + "img/filter-welcome-background-nissan.31f6aab7.png";